import * as CONST from "./actionTypes";

const intialState = {
  signatures: [],
  loading: false,
  error: null,
  messages: {},
  message: {},
  subscribers: {},
  facebooks: {},
  facebook: {},
  forms: {},
  form: {},
  finances: {},
  finance: {},
  instagrams: {},
  instagram: {},
  subscriber: {},
  detailSettings: {},
  updateDetailSettings: {},
  postFinancial: {},
  subadmins: {},
  subadmin: {},
  adminDetail: {},
  getConfigure: {},
  getFieldData: {},
  getInsurance: {},
  insurancelist: [],
  dropdownSubadmin: [],
};

const SignatureReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.ADD_SIGNATURE:
      return {
        ...state,
        error: null,
      };
    case CONST.ADD_SIGNATURE_SUCCESS:
      return {
        ...state,
        signatures: payload,
        error: null,
      };
    case CONST.ADD_SIGNATURE_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.GET_SIGNATURE:
      return {
        ...state,
        error: null,
      };
    case CONST.GET_SIGNATURE_SUCCESS:
      return {
        ...state,
        signatures: payload,
        error: null,
      };
    case CONST.GET_SIGNATURE_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.GET_SIGNATURE_BY_ID:
      return {
        ...state,
        error: null,
      };
    case CONST.GET_SIGNATURE_BY_ID_SUCCESS:
      return {
        ...state,
        signatures: payload,
        error: null,
      };
    case CONST.GET_SIGNATURE_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.UPDATE_SIGNATURE:
      return {
        ...state,
        error: null,
      };
    case CONST.UPDATE_SIGNATURE_SUCCESS:
      return {
        ...state,
        signaturess: payload,
        error: null,
      };
    case CONST.UPDATE_SIGNATURE_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETE_SIGNATURE:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_SIGNATURE_SUCCESS:
      return {
        ...state,
        signatures: payload,
        error: null,
      };
    case CONST.DELETE_SIGNATURE_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  ================= //

    case CONST.GET_MESSAGE_LIST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case CONST.GET_MESSAGE_LIST_SUCCESS:
      return {
        ...state,
        messages: payload,
        error: null,
        loading: false,
      };
    case CONST.GET_MESSAGE_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    //  =================== //

    case CONST.GET_MESSAGE_BY_ID:
      return {
        ...state,
        error: null,
      };
    case CONST.GET_MESSAGE_BY_ID_SUCCESS:
      return {
        ...state,
        message: payload,
        error: null,
      };
    case CONST.GET_MESSAGE_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  ================= //

    case CONST.GET_SUBSCRIBER_LIST:
      return {
        ...state,
        error: null,
        subscribers: {},
        loading: true,
      };
    case CONST.GET_SUBSCRIBER_LIST_SUCCESS:
      return {
        ...state,
        subscribers: payload,
        error: null,
        loading: false,
      };
    case CONST.GET_SUBSCRIBER_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    //  =================== //

    case CONST.GET_SUBSCRIBER_BY_ID:
      return {
        ...state,
        error: null,
        subscriber: {},
      };
    case CONST.GET_SUBSCRIBER_BY_ID_SUCCESS:
      return {
        ...state,
        subscriber: payload,
        error: null,
      };
    case CONST.GET_SUBSCRIBER_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  ================= //

    case CONST.GET_FACEBOOK_LIST:
      return {
        ...state,
        error: null,
        facebooks: {},
        loading: true,
      };
    case CONST.GET_FACEBOOK_LIST_SUCCESS:
      return {
        ...state,
        facebooks: payload,
        error: null,
        loading: false,
      };
    case CONST.GET_FACEBOOK_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    //  =================== //

    case CONST.GET_FACEBOOK_BY_ID:
      return {
        ...state,
        error: null,
        facebook: {},
      };
    case CONST.GET_FACEBOOK_BY_ID_SUCCESS:
      return {
        ...state,
        facebook: payload,
        error: null,
      };
    case CONST.GET_FACEBOOK_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  ================= //

    case CONST.GET_INSTAGRAM_LIST:
      return {
        ...state,
        error: null,
        instagrams: {},
        loading: true,
      };
    case CONST.GET_INSTAGRAM_LIST_SUCCESS:
      return {
        ...state,
        instagrams: payload,
        error: null,
        loading: false,
      };
    case CONST.GET_INSTAGRAM_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    //  =================== //

    case CONST.GET_INSTAGRAM_BY_ID:
      return {
        ...state,
        error: null,
        instagram: {},
      };
    case CONST.GET_INSTAGRAM_BY_ID_SUCCESS:
      return {
        ...state,
        instagram: payload,
        error: null,
      };
    case CONST.GET_INSTAGRAM_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  ================= //

    case CONST.GET_TWITTER_LIST:
      return {
        ...state,
        error: null,
        twitters: {},
        loading: true,
      };
    case CONST.GET_TWITTER_LIST_SUCCESS:
      return {
        ...state,
        twitters: payload,
        error: null,
        loading: false,
      };
    case CONST.GET_TWITTER_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    //  =================== //

    case CONST.GET_TWITTER_BY_ID:
      return {
        ...state,
        error: null,
        twitter: {},
      };
    case CONST.GET_TWITTER_BY_ID_SUCCESS:
      return {
        ...state,
        twitter: payload,
        error: null,
      };
    case CONST.GET_TWITTER_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  ================= //

    case CONST.GET_YOUTUBE_LIST:
      return {
        ...state,
        error: null,
        youtubes: {},
        loading: true,
      };
    case CONST.GET_YOUTUBE_LIST_SUCCESS:
      return {
        ...state,
        youtubes: payload,
        error: null,
        loading: false,
      };
    case CONST.GET_YOUTUBE_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    //  =================== //

    case CONST.GET_YOUTUBE_BY_ID:
      return {
        ...state,
        error: null,
        youtube: {},
      };
    case CONST.GET_YOUTUBE_BY_ID_SUCCESS:
      return {
        ...state,
        youtube: payload,
        error: null,
      };
    case CONST.GET_YOUTUBE_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  ================= //

    case CONST.GET_TIKTOK_LIST:
      return {
        ...state,
        error: null,
        tiktoks: {},
        loading: true,
      };
    case CONST.GET_TIKTOK_LIST_SUCCESS:
      return {
        ...state,
        tiktoks: payload,
        error: null,
        loading: false,
      };
    case CONST.GET_TIKTOK_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    //  =================== //

    case CONST.GET_TIKTOK_BY_ID:
      return {
        ...state,
        error: null,
        tiktok: {},
      };
    case CONST.GET_TIKTOK_BY_ID_SUCCESS:
      return {
        ...state,
        tiktok: payload,
        error: null,
      };
    case CONST.GET_TIKTOK_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  ================= //

    case CONST.GET_FORM_LIST:
      return {
        ...state,
        error: null,
        forms: {},
        loading: true,
      };
    case CONST.GET_FORM_LIST_SUCCESS:
      return {
        ...state,
        forms: payload,
        error: null,
        loading: false,
      };
    case CONST.GET_FORM_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    //  =================== //

    case CONST.GET_FORM_BY_ID:
      return {
        ...state,
        error: null,
        form: {},
      };
    case CONST.GET_FORM_BY_ID_SUCCESS:
      return {
        ...state,
        form: payload,
        error: null,
      };
    case CONST.GET_FORM_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  ================= //

    case CONST.GET_FINANCE_LIST:
      return {
        ...state,
        error: null,
        finances: {},
        loading: true,
      };
    case CONST.GET_FINANCE_LIST_SUCCESS:
      return {
        ...state,
        finances: payload,
        error: null,
        loading: false,
      };
    case CONST.GET_FINANCE_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    //  =================== //

    case CONST.GET_FINANCE_BY_ID:
      return {
        ...state,
        error: null,
        finance: "",
      };
    case CONST.GET_FINANCE_BY_ID_SUCCESS:
      return {
        ...state,
        finance: payload,
        error: null,
      };
    case CONST.GET_FINANCE_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  =================== //

    case CONST.GET_DETAIL_SETTINGS:
      return {
        ...state,
        error: null,
        detailSettings: {},
      };
    case CONST.GET_DETAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        detailSettings: payload,
        error: null,
      };
    case CONST.GET_DETAIL_SETTINGS_FAIL:
      return {
        ...state,
        error: payload,
      };

    //  =================== //

    case CONST.UPDATE_DETAIL_SETTING:
      return {
        ...state,
        error: null,
        updateDetailSettings: {},
      };
    case CONST.UPDATE_DETAIL_SETTING_SUCCESS:
      return {
        ...state,
        updateDetailSettings: payload,
        error: null,
      };
    case CONST.UPDATE_DETAIL_SETTING_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.POST_FINANCIAL:
      return {
        ...state,
        error: null,
        postFinancial: "",
      };
    case CONST.POST_FINANCIAL_SUCCESS:
      return {
        ...state,
        postFinancial: { ...payload },
        error: null,
      };
    case CONST.POST_FINANCIAL_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.POST_SUBADMIN:
      return {
        ...state,
        error: null,
        postSubadmin: "",
      };
    case CONST.POST_SUBADMIN_SUCCESS:
      return {
        ...state,
        postSubadmin: { ...payload },
        error: null,
      };
    case CONST.POST_SUBADMIN_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.GET_SUBADMIN_LIST:
      return {
        ...state,
        error: null,
        subadmins: "",
      };
    case CONST.GET_SUBADMIN_LIST_SUCCESS:
      return {
        ...state,
        subadmins: { ...payload },
        error: null,
      };
    case CONST.GET_SUBADMIN_LIST_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.GET_SUBADMIN_BY_ID:
      return {
        ...state,
        error: null,
        subadmin: "",
      };
    case CONST.GET_SUBADMIN_BY_ID_SUCCESS:
      return {
        ...state,
        subadmin: { ...payload },
        error: null,
      };
    case CONST.GET_SUBADMIN_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.UPDATE_SUBADMIN:
      return {
        ...state,
        error: null,
        updateSubadmin: "",
      };
    case CONST.UPDATE_SUBADMIN_SUCCESS:
      return {
        ...state,
        updateSubadmin: { ...payload },
        error: null,
      };
    case CONST.UPDATE_SUBADMIN_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.DELETE_SUBADMIN:
      return {
        ...state,
        error: null,
        deleteSubadmin: "",
      };
    case CONST.DELETE_SUBADMIN_SUCCESS:
      return {
        ...state,
        deleteSubadmin: { ...payload },
        error: null,
      };
    case CONST.DELETE_SUBADMIN_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.RESET_SUBADMIN_PASS:
      return {
        ...state,
        error: null,
      };
    case CONST.RESET_SUBADMIN_PASS_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.RESET_SUBADMIN_PASS_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.DROPDOWN_SUBADMIN:
      return {
        ...state,
        dropdownSubadmin: [],
        error: null,
      };
    case CONST.DROPDOWN_SUBADMIN_SUCCESS:
      return {
        ...state,
        dropdownSubadmin: payload,
        error: null,
      };
    case CONST.DROPDOWN_SUBADMIN_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.POST_ROLE:
      return {
        ...state,
        error: null,
        postRole: "",
      };
    case CONST.POST_ROLE_SUCCESS:
      return {
        ...state,
        postRole: { ...payload },
        error: null,
      };
    case CONST.POST_ROLE_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.GET_ROLE_LIST:
      return {
        ...state,
        error: null,
        roles: "",
      };
    case CONST.GET_ROLE_LIST_SUCCESS:
      return {
        ...state,
        roles: payload,
        error: null,
      };
    case CONST.GET_ROLE_LIST_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.GET_ROLE_BY_ID:
      return {
        ...state,
        error: null,
        role: "",
      };
    case CONST.GET_ROLE_BY_ID_SUCCESS:
      return {
        ...state,
        role: { ...payload },
        error: null,
      };
    case CONST.GET_ROLE_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.UPDATE_ROLE:
      return {
        ...state,
        error: null,
        updateRole: "",
      };
    case CONST.UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        updateRole: { ...payload },
        error: null,
      };
    case CONST.UPDATE_ROLE_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.DELETE_ROLE:
      return {
        ...state,
        error: null,
        deleteRole: "",
      };
    case CONST.DELETE_ROLE_SUCCESS:
      return {
        ...state,
        deleteRole: { ...payload },
        error: null,
      };
    case CONST.DELETE_ROLE_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.ADMIN_DETAIL:
      return {
        ...state,
        error: null,
        adminDetail: "",
      };
    case CONST.ADMIN_DETAIL_SUCCESS:
      return {
        ...state,
        adminDetail: { ...payload },
        error: null,
      };
    case CONST.ADMIN_DETAIL_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.ROW_SORTING:
      return {
        ...state,
        error: null,
        rowSorting: "",
      };
    case CONST.ROW_SORTING_SUCCESS:
      return {
        ...state,
        rowSorting: { ...payload },
        error: null,
      };
    case CONST.ROW_SORTING_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.POST_CONFIGURE:
      return {
        ...state,
        error: null,
        postConfigure: "",
      };
    case CONST.POST_CONFIGURE_SUCCESS:
      return {
        ...state,
        postConfigure: { ...payload },
        error: null,
      };
    case CONST.POST_CONFIGURE_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.GET_CONFIGURE:
      return {
        ...state,
        error: null,
        getConfigure: "",
      };
    case CONST.GET_CONFIGURE_SUCCESS:
      return {
        ...state,
        getConfigure: { ...payload },
        error: null,
      };
    case CONST.GET_CONFIGURE_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.GET_FIELD_DATA:
      return {
        ...state,
        error: null,
        getFieldData: "",
      };
    case CONST.GET_FIELD_DATA_SUCCESS:
      return {
        ...state,
        getFieldData: payload,
        error: null,
      };
    case CONST.GET_FIELD_DATA_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.SEND_EMAIL_SUBSCRIBER:
      return {
        ...state,
        error: null,
      };
    case CONST.SEND_EMAIL_SUBSCRIBER_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.SEND_EMAIL_SUBSCRIBER_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.SEND_SMS_SUBSCRIBER:
      return {
        ...state,
        error: null,
      };
    case CONST.SEND_SMS_SUBSCRIBER_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.SEND_SMS_SUBSCRIBER_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.HEALTH_INSURANCE_LIST:
      return {
        ...state,
        error: null,
        insurancelist: [],
      };
    case CONST.HEALTH_INSURANCE_LIST_SUCCESS:
      return {
        ...state,
        error: null,
        insurancelist: payload,
      };
    case CONST.HEALTH_INSURANCE_LIST_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.GET_HEALTH_INSURANCE:
      return {
        ...state,
        error: null,
        getInsurance: {},
      };
    case CONST.GET_HEALTH_INSURANCE_SUCCESS:
      return {
        ...state,
        error: null,
        getInsurance: payload,
      };
    case CONST.GET_HEALTH_INSURANCE_FAIL:
      return {
        ...state,
        error: payload,
      };

    // ==================== //

    case CONST.CONVERT_TO_IRS:
      return {
        ...state,
        error: null,
      };
    case CONST.CONVERT_TO_IRS_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.CONVERT_TO_IRS_FAIL:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;

      break;
  }
};

export default SignatureReducer;
